import ls from 'local-storage';

export default {
  name: 'report-base',

  watch: {
    startDate(newValue) {
      ls.set('report.startDate', newValue);
    },

    endDate(newValue) {
      ls.set('report.endDate', newValue);
    },
  },
}